import { render, staticRenderFns } from "./productProperti.vue?vue&type=template&id=336fffac&"
import script from "./productProperti.vue?vue&type=script&lang=ts&"
export * from "./productProperti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports